import { withUnmountTransition } from '../../../../misc/withUnmountTransition.hoc'
import { DeleteValidationModal } from './DeleteValidationModal.component'

const withUnmountHoc = withUnmountTransition(DeleteValidationModal)
export { withUnmountHoc as DeleteValidationModal }
